import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Auth/get-user-by-token`
export const GET_TOKEN_URL = `${API_URL}/Auth/get-token`
export const LOGIN_URL = `${API_URL}/Auth/login`
export const REGISTER_URL = `${API_URL}/Auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/Auth/forgot_password`
export const APPROVE_URL = `${API_URL}/Auth/approve`



// Server should return AuthModel
export function login(userName: string, password: string) {
  return axios.post<AuthModel>(GET_TOKEN_URL, {
    userName,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.put(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string, identity: string) {
    return axios.post(REQUEST_PASSWORD_URL, { email: email, identity: identity })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token
  })
}

// Server should return ok
export function approve(
    approveGuid: string, password: string
) {
    return axios.post(`${APPROVE_URL}?guid=${approveGuid}&password=${password}`)
}
